/* ------------------------------------------------------------------
   File: InvestmentOverview.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-01-08
------------------------------------------------------------------ */

import React from 'react'

function InvestorOverview() {
  return (
    <div>
      Investor Overview
    </div>
  )
}

export default InvestorOverview

